import React from 'react';
import '../../assets/styles/Blog.css';

interface ShareButtonsProps {
  title: string;
  url: string;
  summary?: string;
}

const ShareButtons: React.FC<ShareButtonsProps> = ({ title, url, summary = '' }) => {
  const encodedTitle = encodeURIComponent(title);
  const encodedUrl = encodeURIComponent(url);
  const encodedSummary = encodeURIComponent(summary);

  // Generate sharing URLs
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`;
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
  const pinterestUrl = `https://pinterest.com/pin/create/button/?url=${encodedUrl}&description=${encodedTitle}`;
  const emailUrl = `mailto:?subject=${encodedTitle}&body=${encodedSummary}%0A%0A${encodedUrl}`;

  // Function to handle share button clicks
  const handleShare = (shareUrl: string) => {
    window.open(shareUrl, '_blank', 'width=600,height=400');
  };

  return (
    <div className="blog-share">
      <h4 className="blog-share-title">Share this post</h4>
      <div className="blog-share-buttons">
        <button 
          className="blog-share-button facebook" 
          onClick={() => handleShare(facebookUrl)}
          aria-label="Share on Facebook"
        >
          <span className="blog-share-icon">f</span>
        </button>
        <button 
          className="blog-share-button twitter" 
          onClick={() => handleShare(twitterUrl)}
          aria-label="Share on Twitter"
        >
          <span className="blog-share-icon">X</span>
        </button>
        <button 
          className="blog-share-button linkedin" 
          onClick={() => handleShare(linkedinUrl)}
          aria-label="Share on LinkedIn"
        >
          <span className="blog-share-icon">in</span>
        </button>
        <button 
          className="blog-share-button pinterest" 
          onClick={() => handleShare(pinterestUrl)}
          aria-label="Share on Pinterest"
        >
          <span className="blog-share-icon">P</span>
        </button>
        <a 
          className="blog-share-button email" 
          href={emailUrl}
          aria-label="Share via Email"
        >
          <span className="blog-share-icon">✉</span>
        </a>
      </div>
    </div>
  );
};

export default ShareButtons; 